import { api, RTKTags } from '@/store/api'

import Env from '../../../env/env'

import type {
  findSubjectRequest,
  findSubjectResponse,
  getStatsResponse,
  getStatusRequest,
  getStatusResponse,
  listOfUseCasesResponse,
  listPaginatedOfTopicsRequest,
  listPaginatedOfTopicsResponse,
  startNewPersonSearchRequest,
  checkPrivacyRequest,
  checkPrivacyResponse,
} from './NewSearch.types'

export const planApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // useListPaginatedOfTopicsQuery
    listPaginatedOfTopics: builder.query<
      listPaginatedOfTopicsResponse,
      listPaginatedOfTopicsRequest
    >({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/topics`,
        method: 'GET',
        params: {
          page: request.page,
          pageSize: request.pageSize,
          status: request.status,
        },
      }),
    }),

    // useListOfUseCasesQuery
    listOfUseCases: builder.query<listOfUseCasesResponse, void>({
      query: () => ({
        url: `${Env.BASE_API_URL}/api/v1/use-cases`,
        method: 'GET',
      }),
    }),

    // useStartNewPersonSearchMutation
    startNewPersonSearch: builder.mutation<
      { info: { id: string; subjectId: string } },
      startNewPersonSearchRequest
    >({
      query: (request) => {
        const { ...filteredRequest } = request

        return {
          url: `${Env.BASE_API_URL}/api/v1/subjects`,
          method: 'POST',
          body: { ...filteredRequest },
        }
      },
      invalidatesTags: [
        RTKTags.userInfo,
        RTKTags.monitoringCenter,
        RTKTags.accountDetails,
        RTKTags.accountCredits,
      ],
    }),

    // useGetStatsQuery
    getStats: builder.query<getStatsResponse, void>({
      query: () => ({
        url: `${Env.BASE_API_URL}/api/v1/accounts/stats`,
        method: 'GET',
      }),
      providesTags: [RTKTags.userInfo],
    }),

    // useFindSubjectMutation
    findSubject: builder.mutation<findSubjectResponse, findSubjectRequest>({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/subjects/find`,
        method: 'POST',
        body: { ...request },
      }),
    }),

    // useLazyGetReportStatusQuery
    getReportStatus: builder.query<getStatusResponse, getStatusRequest>({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/subjects/${request.subjectId}/status`,
        method: 'GET',
      }),
      providesTags: [RTKTags.userInfo],
    }),

    // useCheckProfilesPrivacyMutation
    checkProfilesPrivacy: builder.mutation<
      checkPrivacyResponse,
      checkPrivacyRequest
    >({
      query: (request) => ({
        url: `${Env.BASE_API_URL}/api/v1/subjects/check-privacy`,
        method: 'POST',
        body: request,
      }),
    }),
  }),
})

export const {
  useListPaginatedOfTopicsQuery,
  useListOfUseCasesQuery,
  useStartNewPersonSearchMutation,
  useGetStatsQuery,
  useFindSubjectMutation,
  useLazyGetReportStatusQuery,
  useCheckProfilesPrivacyMutation,
} = planApi
